import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import {router, store} from './router'
import VueMathjax from 'vue-mathjax'
import * as VueThreeJs from 'vue-threejs'; // >= 0.2.0
import VueExcelEditor from 'vue-excel-editor'
import './assets/main.scss'

Vue.config.productionTip = false

Vue.config.errorHandler = function (err) {
  if (vueInstance) {
    vueInstance.$store.commit('setAppError', err);
  }
  let c = console;
  c.error(err);
};

Vue.use(VueMathjax);
Vue.use(VueThreeJs);
Vue.use(VueExcelEditor);

let vueInstance = new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
